import {NavItem} from './nav-item/nav-item';

export const navItems: NavItem[] = [
  {
    code : "HOME",
    displayName: 'home',
    iconName: 'home',
    route: '/dashboard/home',
  },
  /*
  {
    code : "REPAIRS-DASH",
    displayName: 'repairs',
    iconName: 'chart-donut-3',
    route: '/dashboard/repair',
  },*/
  {
    code : "MY-DEVICES",
    displayName: 'my-devices',
    iconName: 'devices',
    route: 'management/my-devices',
  },
  {
    code : "CENTERS",
    displayName: 'centers',
    iconName: 'building',
    route: 'management/centers',
  },
  /*
  {
    displayName: 'comunication',
    iconName: 'messages',
    route: 'apps/email/inbox',
  },
  {
    displayName: 'issues',
    iconName: 'alert-triangle',
    route: 'apps/contacts',
  },
  */
  {
    code : "REPAIRS-RMA",
    displayName: 'create-rma',
    iconName: 'point',
    route: 'management/repairs/rma-creator',
  },
  {
    code : "REPAIRS-PRO",
    displayName: 'in-repair',
    iconName: 'point',
    route: 'management/repairs/inProgress',
  },
  {
    code : "REPAIRS-HIS",
    displayName: 'history',
    iconName: 'point',
    route: 'management/repairs/history',
  },
  {
    code : "CONTRACTS",
    displayName: 'contracts',
    iconName: 'file-certificate',
    route: 'management/contracts',
  },
  /*
  {
    displayName: 'docu-sign',
    iconName: 'assembly',
    route: 'apps/notes',
  },*/
  {
    code : "SHIPMENTS",
    displayName: 'shipments',
    iconName: 'box-seam',
    route: 'management/shipments',
  },
  {
    code : "RENT",
    displayName: 'rent',
    iconName: 'versions',
    route: 'management/rent',
  },
  {
    code : "INVOICES",
    displayName: 'invoices',
    iconName: 'receipt-euro',
    route: 'management/invoices',
  },
  {
    code : "BUDGETS",
    displayName: 'budgets',
    iconName: 'coin-euro',
    route: 'management/budgets',
  },
  /*{
    code : "CALENDAR",
    displayName: 'calendar',
    iconName: 'calendar',
    route: 'management/calendar',
  },*/
  {
    code : "CONTACTS",
    displayName: 'contacts',
    iconName: 'phone',
    route: 'management/contacts',
  },
  {
    code : "USERS",
    displayName: 'users',
    iconName: 'users-group',
    route: 'my-acount/users',
  },
  {
    code : "FAQ",
    displayName: 'faq',
    iconName: 'help-circle',
    route: 'management/faq',
  },

];
